import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=2778efe8&"
import script from "./UploadModal.vue?vue&type=script&lang=js&"
export * from "./UploadModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2778efe8')) {
      api.createRecord('2778efe8', component.options)
    } else {
      api.reload('2778efe8', component.options)
    }
    module.hot.accept("./UploadModal.vue?vue&type=template&id=2778efe8&", function () {
      api.rerender('2778efe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/services/UploadModal.vue"
export default component.exports